
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleetShowersDayColour as ObiLightningLightSleetShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet-showers-day-colour.js';
 
 
 

 
 export const ObiLightningLightSleetShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet-showers-day-colour',
   elementClass: ObiLightningLightSleetShowersDayColourElement,
   events: {
     
   }
  });
 
 